export default __webpack_public_path__ + "static/media/ic-arrow-prev.6c294d68.svg";